import prop from 'ramda/src/prop'
import length from 'ramda/src/length'
import differenceWith from 'ramda/src/differenceWith'
import find from 'ramda/src/find'
import reduce from 'ramda/src/reduce'
import propEq from 'ramda/src/propEq'
import equals from 'ramda/src/equals'
import allPass from 'ramda/src/allPass'

import isOneOfAssigneesSelector from 'root/src/client/logic/project/selectors/isOneOfAssigneesSelector'
import statusSelector from 'root/src/client/logic/project/selectors/statusSelector'
import userRejectedDareSelector from 'root/src/client/logic/project/selectors/userRejectedDareSelector'
import projectAssigneesSelector from 'root/src/client/logic/project/selectors/projectAssigneesSelector'
import tokensSelector from 'root/src/client/logic/api/selectors/tokensSelector'

import {
	notConnected,
	connectedNotClaimed,
	accepted,
	notEligible,
	videoPending,
	videoApprovedCreator,
	videoApprovedNotCreator,
	creatorRejectedStatus,
	pending,
} from 'root/src/shared/constants/projectAcceptanceStatuses'
import {
	creatorPendingKey,
	creatorAcceptedKey,
	projectDeliveredKey,
	projectDeliveryPendingKey,
	assigneePlatformKey,
	platformIdKey,
	projectPendingKey,
} from 'root/src/shared/constants/keys'

export default (state, props) => {
	const userTokens = tokensSelector(state, props)
	const isAssignee = isOneOfAssigneesSelector(state, props)
	const assignees = projectAssigneesSelector(state, props)
	const hasDiffPlatforms = !!length(
		differenceWith((a, b) => a.platform === b.platform, assignees, userTokens),
	)
	if (!hasDiffPlatforms && !isAssignee) {
		return notEligible
	}
	const projectStatus = statusSelector(state, props)

	if (equals(projectStatus, projectPendingKey)) {
		return pending
	}

	if (equals(projectStatus, projectDeliveredKey)) {
		if (isAssignee) {
			return videoApprovedCreator
		}
		return videoApprovedNotCreator
	}
	if (!isAssignee) {
		return userRejectedDareSelector(state, props) ? creatorRejectedStatus : notConnected
	}

	const acceptanceStatus = reduce((acc, { platform, platformId }) => {
		if (acc) {
			return acc
		}
		return prop('accepted', find(allPass([
			propEq(platformIdKey, platformId),
			propEq(assigneePlatformKey, platform),
		]), assignees))
	}, undefined, userTokens)

	if (equals(projectStatus, projectDeliveredKey)) {
		if (isAssignee) {
			return videoApprovedCreator
		}
		return videoApprovedNotCreator
	}

	switch (acceptanceStatus) {
	case (creatorPendingKey):
		return connectedNotClaimed
	case (creatorAcceptedKey):
		return equals(projectStatus, projectDeliveryPendingKey)
			? videoPending
			: accepted
	case (creatorRejectedStatus):
		return notEligible
	default:
		return notEligible
	}
}
